import { Vector3 as BABYLON_Vector3 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
import { Light as BABYLON_Light } from '@inter-ikea-betrakta-babylonjs/core/Lights/light.js';
import { HemisphericLight as BABYLON_HemisphericLight } from '@inter-ikea-betrakta-babylonjs/core/Lights/hemisphericLight.js';
import { Color3 as BABYLON_Color3 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.color.js';
// TODO: Should use ConstantReference in the future
/**
 * A controller for the viewer's main light.
 */
export class AmbientLightController {
    constructor(_viewer) {
        this._viewer = _viewer;
        this.name = 'viewer ambient light';
        this._ambient_light = new BABYLON_HemisphericLight(this.name, new BABYLON_Vector3(0, 1, 0), this._viewer.scene);
        this._ambient_light.lightmapMode = BABYLON_Light.LIGHTMAP_DEFAULT;
        this._ambient_light.intensityMode = BABYLON_Light.INTENSITYMODE_ILLUMINANCE;
        this._ambient_light.diffuse = new BABYLON_Color3(1, 1, 1);
        this._ambient_light.shadowEnabled = false;
        this._ambient_light.groundColor = new BABYLON_Color3(0.25, 0.25, 0.25);
    }
    set_enabled(enabled) {
        this._ambient_light.setEnabled(enabled);
        this._viewer.freezing_manager.set_all_materials_dirty();
        this._viewer.mark_scene_dirty();
    }
    is_enabled() {
        return this._ambient_light.isEnabled();
    }
    set_intensity(intensity) {
        this._ambient_light.intensity = intensity;
        this._viewer.freezing_manager.set_all_materials_dirty();
        this._viewer.mark_scene_dirty();
    }
    set_color(color) {
        this._ambient_light.diffuse = new BABYLON_Color3(color.r, color.g, color.b);
        this._viewer.freezing_manager.set_all_materials_dirty();
        this._viewer.mark_scene_dirty();
    }
    set_ground_color(color) {
        this._ambient_light.groundColor = new BABYLON_Color3(color.r, color.g, color.b);
        this._viewer.freezing_manager.set_all_materials_dirty();
        this._viewer.mark_scene_dirty();
    }
    dispose() {
        this._ambient_light.dispose();
    }
}
//# sourceMappingURL=AmbientLightController.js.map